import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import logo from './logo.png';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = () => {
  const { t } = useTranslation();
  const navbarRef = useRef(null);
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Handle mobile menu open/close and body scroll
  useEffect(() => {
    const handleClickOutside = (event) => {
      const navbarCollapse = document.getElementById('navbarNav');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        // Check if click is outside the navbar
        if (!navbarRef.current.contains(event.target)) {
          // Force close the mobile menu
          navbarCollapse.classList.remove('show');
          document.body.classList.remove('mobile-menu-open');
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.width = '';
          document.body.style.height = '';
          
          // Also close any open dropdowns
          const openDropdowns = navbarCollapse.querySelectorAll('.dropdown-menu.show');
          openDropdowns.forEach(dropdown => {
            dropdown.classList.remove('show');
          });
        }
      }
    };

    // Listen for Bootstrap collapse events
    const navbarCollapse = document.getElementById('navbarNav');
    if (navbarCollapse) {
      navbarCollapse.addEventListener('show.bs.collapse', () => {
        document.body.classList.add('mobile-menu-open');
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';
      });
      
      navbarCollapse.addEventListener('hide.bs.collapse', () => {
        document.body.classList.remove('mobile-menu-open');
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.height = '';
      });
    }

    // Add event listeners for outside clicks
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.body.classList.remove('mobile-menu-open');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, []);

  // Handle scroll behavior for mobile navbar
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Only apply scroll behavior on mobile (screen width <= 768px)
      if (window.innerWidth <= 768) {
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
          // Scrolling down and past 100px - hide navbar
          setIsScrollingDown(true);
        } else {
          // Scrolling up or at top - show navbar
          setIsScrollingDown(false);
        }
      } else {
        // On desktop, always show navbar
        setIsScrollingDown(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <nav className={`navbar navbar-expand-lg navbar-dark navbar-custom ${isScrollingDown ? 'navbar-hidden' : ''}`} ref={navbarRef}>
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="Ayaat Logo"/>
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item"><Link className="nav-link" to="/about">{t('navbar.about')}</Link></li>
            <li className="nav-item dropdown">
              <button className="nav-link dropdown-toggle" id="servicesDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                {t('navbar.services')}
              </button>
              <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="servicesDropdown">
                <li><Link className="dropdown-item" to="/steel">{t('navbar.steel')}</Link></li>
                <li><Link className="dropdown-item" to="/marble">{t('navbar.marble')}</Link></li>
                <li><Link className="dropdown-item" to="/contracting">{t('navbar.contracting')}</Link></li>
              </ul>
            </li>
            <li className="nav-item"><Link className="nav-link" to="/projects">{t('navbar.projects')}</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/contact">{t('navbar.contact')}</Link></li>
          </ul>
          <div className="navbar-nav">
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
